<template>
  <div id="creditSearch">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="途径">
        <el-select style="width: 100px" size="mini" v-model="searchForm.ruleId" placeholder="请选择">
          <el-option
            v-for="item in rulelList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="获取时间">
        <el-date-picker
          style="width: 250px"
          size="mini"
          v-model="searchForm.getTimeRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="exportToExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="sellerName" label="用户名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="getWay" label="途径" :formatter="wayFormatter"></el-table-column>
      <el-table-column prop="content" label="内容"></el-table-column>
      <el-table-column prop="getTime" label="获得时间" :formatter="dateFormatter"></el-table-column>
      <el-table-column prop="creditChange" label="积分变动"></el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "credit-search",
    data(){
        return{
          rulelList:[],
          searchForm:{
            ruleId:null,
            getTimeRange:"",
            keyWords:""
          },
          tableData:[],
          pageInfo:{
            currentPage:1,
            pageSize:20,
            total:0
          },
          multipleSelection:[],
          selectIds:[]
        }
    },
    created(){
      this.getRuleList();
      this.getData()
    },
    methods:{
      getRuleList(){
        this.$httpRequest.get("/api/creditManage/getRuleWorkWay").then(res=>{
          this.rulelList = res.data.list;
        })
      },
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        utils.axiosMethods({
          method:"POST",
          url:"/api/creditManage/queryCredit",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            ruleId:this.searchForm.ruleId,
            getTimeStart:this.searchForm.getTimeRange? this.searchForm.getTimeRange[0]+ " 00:00:00" : null,
            getTimeEnd:this.searchForm.getTimeRange?this.searchForm.getTimeRange[1]+ " 23:59:59":null,
            keyWords:this.searchForm.keyWords
          },
          callback:(res => {
            this.tableData = res.data.list;
            this.pageInfo.total = res.data.total;
            loading.close()
          }),
          catch:(err => {
            loading.close()
          })
        })
      },
      onSearch(){
        this.getData();
      },
      exportToExcel(){
        if(this.selectIds.length <= 0){
          this.$message.error('错了哦，请选择一条或者多条数据');
        }else{
          window.open("/api/creditManage/exportToExcel?ids="+this.selectIds.join(','),"_parent");
        }
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index){
        return utils.dateFormat(cellValue,"yyyy-MM-dd HH:mm:ss")
      },
      wayFormatter(row, column, cellValue, index){
        return this.rulelList.find(d=>d.id == cellValue).name
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let ids = [];
        val.map(item => {
          ids.push(item.id)
        });
        this.selectIds = ids;
      },
    }
  }
</script>

<style scoped lang="less">
  #creditSearch{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/creditSearch.vue